import { render, staticRenderFns } from "./msgCenter.vue?vue&type=template&id=3b38f6b8&scoped=true&"
import script from "./msgCenter.vue?vue&type=script&lang=js&"
export * from "./msgCenter.vue?vue&type=script&lang=js&"
import style0 from "./msgCenter.vue?vue&type=style&index=0&id=3b38f6b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38f6b8",
  null
  
)

export default component.exports